import { createEntityAdapter, EntityState } from '@ngrx/entity';
import {
    DiagnosesicherheitActions,
    DiagnosesicherheitActionTypes,
} from '../../actions/mdqx/diagnosesicherheit.actions';
import { DiagnosesicherheitEntity } from '../../../entities/mdqx/diagnosesicherheit.entity';

export interface DiagnosesicherheitState extends EntityState<DiagnosesicherheitEntity> {
    fetched: boolean;
}

export const DIAGNOSESICHERHEIT_KEY = 'diagnosesicherheit';

const adapter = createEntityAdapter<DiagnosesicherheitEntity>({
    selectId: diagnosesicherheit => diagnosesicherheit.Id,
});

const initialState: DiagnosesicherheitState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function diagnosesicherheitReducer(state = initialState, action: DiagnosesicherheitActions) {
    switch (action.type) {
        case DiagnosesicherheitActionTypes.GetDiagnosesicherheitenResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        case DiagnosesicherheitActionTypes.PostDiagnosesicherheitResponse: {
            return adapter.addOne(action.Payload, state);
        }

        case DiagnosesicherheitActionTypes.PatchDiagnosesicherheitResponse: {
            return adapter.setOne(action.Payload, state);
        }

        case DiagnosesicherheitActionTypes.DeleteDiagnosesicherheitResponse: {
            return adapter.removeOne(action.Payload, state);
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllDiagnosesicherheiten = selectAll;

export const selectDiagnosesicherheitenFetched = (state: DiagnosesicherheitState) => state.fetched;
